import React from 'react';
import audioLink from '../../../../assets/audios/newMessage.mp3';
import ImageIcon from '../../../../assets/img/message.png';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';

const ClickToastArea = ({ name, idChat, IsNotificationScheduling }) => {
  const history = useHistory();

  const handlerClick = async (idChat) => {
    if (IsNotificationScheduling) {
      history.push(`/admin/protocol`, {
        idChat,
        IsNotificationScheduling: true
      });
    } else {
      history.push(`/admin/service_panel`, { idChat });
    }
  };

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        cursor: 'pointer',
        padding: '10px'
      }}
      onClick={() => {
        handlerClick(idChat)
          .then((data) => {})
          .catch((error) => {
            console.log('error ==>', error);
          });
      }}
    >
      {name}
    </div>
  );
};

export const PlayNewAlert = (
  data,
  permission,
  type,
  audioNotification,
  IsNotificationScheduling
) => {
  if (IsNotificationScheduling) {
    let audio = new Audio(audioLink);

    const dateObject = new Date(data.createdAt);
    const offsetHours = dateObject.getUTCHours() - 3;
    const minutes = dateObject.getUTCMinutes();

    const adjustedHours = (offsetHours + 24) % 24;

    const formattedTime = `${String(adjustedHours).padStart(2, '0')}:${String(
      minutes
    ).padStart(2, '0')}`;

    const protocoloRegex = /Protocolo N° (\d+)/;

    const match = data?.content.match(protocoloRegex);
    const protocoloNumber = match ? match[1] : null;

    const audioNotificationVolume =
      localStorage.getItem('@flexuc/audioNotificationVolume') || 1;

    audio.volume = audioNotificationVolume;

    const menssageBody = `Você tem um agendamento às ${formattedTime}h referente ao protocolo N° ${protocoloNumber} `;

    const audioEnabled = JSON.parse(
      localStorage.getItem('@flexuc/audioEnabled')
    );

    if (permission === 'granted') {
      const notification = new Notification('FlexUC', {
        body: menssageBody,
        icon: ImageIcon
      });
      const origin = window.location.origin;
      notification.onclick = function () {
        window.open(
          `${origin}/admin/protocol/${data.protocolId}/update`,
          '_blank'
        );
        window.focus();
      };
    } else {
      toast.info(
        <ClickToastArea
          name={menssageBody}
          idChat={data.protocolId}
          IsNotificationScheduling={true}
        />
      );
    }
    if (audioEnabled) audio.play();
  } else {
    const idDaConversa = data.idDaConversa || data.id || data._id;
    let audio = new Audio(audioLink);
    if (audioNotification !== null && audioNotification !== undefined) {
      audio = new Audio(audioNotification);
    }

    const title = () => {
      if (type === 'client in queue') {
        return 'Cliente em fila de espera';
      } else if (type === 'new menssage') {
        return 'Nova mensagem';
      } else {
        return 'Atendimento exclusivo';
      }
    };
    const audioNotificationVolume =
      localStorage.getItem('@flexuc/audioNotificationVolume') || 1;

    audio.volume = audioNotificationVolume;

    const menssageBody = data?.mensagem?.escrita_por
      ? `No atendimento do cliente ${data?.mensagem?.escrita_por}`
      : `O cliente ${data?.cliente?.nome} entrou na fila ${data?.fila}`;

    const audioEnabled = JSON.parse(
      localStorage.getItem('@flexuc/audioEnabled')
    );

    if (permission === 'granted') {
      const notification = new Notification('FlexUC', {
        body: menssageBody,
        icon: ImageIcon
      });
      const origin = window.location.origin;

      notification.onclick = function () {
        window.open(`${origin}/admin/service_panel/${idDaConversa}`, '_blank');
        window.focus();
      };
    } else {
      toast.info(<ClickToastArea name={menssageBody} idChat={idDaConversa} />);
    }
    if (audioEnabled) audio.play();
  }
};
